export default __webpack_public_path__ + "static/wave-9b0dd7a6825d287fcd532d28c22fb151.mp4";